module.exports = __webpack_public_path__ + "static/media/search-personalization-click-through-rate.c1197395.png";